'use client';
import React from 'react';
import { LoginPrompt } from './loginPrompt';
import { useIsUserLoggedIn } from './hooks/useIsUserLoggedIn';
import { HijackComponent } from './hijackComponent';

interface Props {
  children: React.ReactNode | ((state: boolean) => React.ReactNode);
  doNotDisplayPrompt?: boolean;
  doNotStopPropagation?: boolean;
  /** @deprecated Anonymous feature clicks always open the login modal; this flag has no effect. */
  forceLogin?: boolean;
}

export const LoggedInComponent: React.FC<Props> = props => {
  const [isDisplayingPrompt, setIsDisplayingPrompt] = React.useState(false);

  const isLoggedIn = useIsUserLoggedIn();

  const onDisplay = React.useCallback(() => {
    setIsDisplayingPrompt(!props.doNotDisplayPrompt);
  }, [props.doNotDisplayPrompt]);
  const onClose = React.useCallback(() => setIsDisplayingPrompt(false), []);

  const content = React.useMemo(() => {
    const childrenFunc = props.children;
    return typeof childrenFunc === 'function' ? childrenFunc(isLoggedIn) : childrenFunc;
  }, [isLoggedIn, props.children]);

  return (
    <>
      {isDisplayingPrompt && <LoginPrompt onClose={onClose} />}
      <HijackComponent doNotStopPropagation={props.doNotStopPropagation} hijack={!isLoggedIn} onHijackClick={onDisplay}>
        {content}
      </HijackComponent>
    </>
  );
};
